import HomeTabs from "../../molecules/homeTabs/HomeTabs";
import HomePageHeading from "../../molecules/homePageHeading/homePageHeading";
import CardsCarousel from "../../molecules/cardsCarousel/CardsCarousel";
import {
  useRouter,
  Container,
  CustomContainer,
} from "../../atoms/DependencyHelper";
import ajaxService from "../../../utils/ajaxServices";
import styles from "./DealCatalog.module.scss";
import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import CTAButton from "../../atoms/CTAButton/CTAButton";
import ProductCarousel from "../../molecules/ProductCarousel/ProductCarousel";
import {
  goToUrl,
  getRequestBody,
  requestType,
  getFinalPrice,
  getDealExpiryTime,
} from "../../../utils/helperServices";

import * as Analytics from "../../../services/analyticsUtag";
import ProductGridList from "../../molecules/ProductGridList/ProductGridList";

const config = require("../../../config/index");
const env = config.env;
const server = config.envConfigs[env].server;
const url = `${server}${config.graphqlUrl}`;
const urlPrefix = config.envConfigs[env].shoppingUrlPrefix;

const DealCatalog = ({ component, analyticsData,campaignFlag }) => {
  const {comingSoonColor,endingSoonColor}=component
  const router = useRouter();
  const tempKeys = component?.productCategory;
  const totalKeys = tempKeys.length;
  const [tabsToRender, pushTabs] = useState([]);
  const syncArray = [];
  const attributes = [
    "page_name",
  "page_channel",
  "page_master_tab",
  "visitor_login_status",
  "visitor_customer_id",
  "visitor_id_hash",
  "visitor_msisdn_hash",
  "visitor_subscription_type"
  ];
  var isAnalytics=false
  const redirectToProducts = () => {
    let url = component.callToActionUrl;
    if (component.callToActionUrl.includes("internal:")) {
      url = component.callToActionUrl.split("internal:")[1];
    }
    goToUrl(url, router);
    handleShopAllAnalytics();
  };

  const handleShopAllAnalytics = () => {
    const viewData = Analytics.getUtagData(attributes);
    Analytics.link({
      ...viewData,
      link_type: "o",
      link_name: `${viewData?.page_name}: all deals: ${component.title}`,
    })
  };

  const handleProductCTA = (product) => {
    let contracts = Array.isArray(product.contract_sku) ? product.contract_sku : [`${product.contract_sku}`];
    router.push({ pathname: `${urlPrefix}/deal-details-page/${product.sku}`, query: { contractSkus: contracts } })
    .then(()=>{typeof(window)!==undefined&& window.scrollTo(0,0)})
    if (!isAnalytics) {
      const viewData = Analytics.getUtagData(attributes);
      const data = {
        link_type: "o",
        link_name: `${viewData.page_name}: deal select: ${component.title}: ${product?.tabName}`,
        sales_product_category: [product?.categories],
        sales_product_id: [product?.name],
        sales_product_price: [product.monthly_recurring],
        sales_product_quantity: [1],
      }
      if (product?.promotion_tag_label) {
        data.sales_promo_name = [product?.promotion_tag_label];
      }
      if (product?.deal_end_date) {
        data.deal_expiry = getDealExpiryTime(product?.deal_end_date);
      }
      if (product.old_monthly_recurring && product.old_monthly_recurring !== product.monthly_recurring) {
        data.sales_order_discount = Math.abs((product.old_monthly_recurring - product.monthly_recurring));
      }
      isAnalytics=true
      Analytics.link({
        ...data
      });
    }
  };

  const apiMethod = component.API.method
    ? component.API.method
    : component.API.single.method;

  const body = getRequestBody(component.API);

  const requestBodyUrl = apiMethod === "GET" ? body.replace(url, "") : body;

  const generateData = async (requestBody, method, tempkey, allSku) => {
    try {
      const results =
        method === "GET"
          ? await ajaxService.fetchGraphQLGetRequest(requestBody.split("=")[1])
          : await ajaxService.fetchGraphQLPOSTRequest(requestBody);
      const sortedArray = [];
      allSku.forEach((item) =>
        results?.products?.items.find((category) => {
          if (category.sku === item) {
            const productWithTabName = {tabName: tempkey, ...category};
            sortedArray.push(productWithTabName);
          }
        })
      );
      if (!Object.keys(component.productCategory[0]).includes("tab")) {
        syncArray.push(sortedArray);
      } else if (component.displayStyle === "Carousel") {
        syncArray.push({
          title: tempkey,
          component: (
            <div>
              <Container className={`text-center ${styles["deal-carousel-container"]}`}>
                <ProductCarousel
                  ProductCarouselData={sortedArray}
                  isDeal
                  width="15.5rem"
                  availableIn={comingSoonColor}
                  endsIn={endingSoonColor}
                  img_width="11.25rem"
                  img_height="11.25rem"
                  width_mobile="12.375rem"
                  img_width_mobile="8.375rem"
                  img_height_mobile="8.375rem"
                  navigateTo={handleProductCTA}
                  alignment={component?.heading_position}
                  campaignFlag={campaignFlag}
                  carouselId="shop-deal-carousel"
                />
                </Container>
                <Container className="text-center">
                  <CTAButton
                    className={`${styles["shop-all"]}`}
                    handleClick={handleShopAllAnalytics}
                    url={component.callToActionUrl}
                    isOpenNewTab={component?.isOpenNewTab}
                    variant="outline grey"
                    id="product-carousel"
                    >
                    {component.buttonLabel
                      ? component.buttonLabel
                      : component.callToActionLabel}
                  </CTAButton>
                </Container>
              </div>
          ),
        });
      } else {
        syncArray.push({
          title: tempkey,
          component: (
            <Container className="text-center">
              <CardsCarousel cards={sortedArray} />
              <CTAButton
                className={`${styles["shop-all"]}`}
                handleClick={handleShopAllAnalytics}
                url={component.callToActionUrl}
                variant="outline grey"
                id="cards-carousel"
              >
                {component.buttonLabel
                  ? component.buttonLabel
                  : component.callToActionLabel}
              </CTAButton>
            </Container>
          ),
        });
      }
    } finally {
      let updatedArray = [];
      if (
        Object.keys(component.API).includes("all") ? totalKeys + 1 : totalKeys
      ) {
        if (!Object.keys(component.productCategory[0]).includes("tab")) {
          updatedArray = syncArray;
        } else {
          tempKeys.forEach((category) => {
            const newItem = syncArray.filter((item) => {
              if (category.tab === item.title) {
                updatedArray.push(item);
              }
            });
          });
        }
      }
      if (
        Object.keys(component.API).includes("all") &&
        syncArray.filter((item) => item.title === "All").length
      ) {
        updatedArray.unshift(
          syncArray.filter((item) => item.title === "All")[0]
        );
      }
      if (
        updatedArray.length ===
        (Object.keys(component.API).includes("all") ? totalKeys + 1 : totalKeys)
      ) {
        pushTabs(updatedArray);
      }
    }
  };
  useEffect(() => {
    async function generateTabs() {
      if (Object.keys(component.API).includes("all")) {
        const newArray = tempKeys.map((item) => item.productSku);
        const newKeys = [].concat.apply([], newArray);
        let allkeys = newKeys.join('","');
        const requestBody =
          requestType(component.API.all).replace("<productSku>", allkeys) || "";
        generateData(requestBody, component.API.all.method, "All", newKeys);
      }
      for (let i = 0; i < totalKeys; i++) {
        let allkeys = tempKeys[i].productSku.join('","');
        const requestBody =
          requestBodyUrl.replace("<productSku>", allkeys) || "";
        generateData(requestBody, apiMethod, tempKeys[i].tab, tempKeys[i].productSku);
      }
    }
    if (component.displayStyle !== "Grid") {
      generateTabs();
    }
  }, []);
  console.log(component)
  return (
    <>
      <HomePageHeading
        text={component.title}
        secondaryText={component.displayStyle === "Grid" ? null : component?.description || component.title}
        textClassName={styles["heading"]}
        componentDescription={component.displayStyle === "Grid" ? component?.description : null}
        mainHeadingRequired={component?.description}
        alignment={component?.heading_position || "LEFT"}
      />
        {component.displayStyle === "Grid" && (
          <Container>
            <ProductGridList
              isDeal
              width="315px"
              img_width="11.25rem"
              img_height="11.25rem"
              width_mobile="12.375rem"
              img_width_mobile="8.375rem"
              img_height_mobile="8.375rem"
              navigateTo={redirectToProducts}
              component={component}
            />
          </Container>
        )}
      {!Object.keys(component.productCategory[0]).includes("tab") ?
        tabsToRender.length > 0 && (
          <CustomContainer className="pt-l">
            <ProductCarousel
              ProductCarouselData={tabsToRender[0]}
              isDeal
              hideButtons={component.displayStyle === "Grid"}
              width="15.5rem"
              img_width="11.25rem"
              img_height="11.25rem"
              width_mobile="12.375rem"
              img_width_mobile="8.375rem"
              img_height_mobile="8.375rem"
              navigateTo={redirectToProducts}
            />
          </CustomContainer>
        )
        : tabsToRender.length > 0 && (
          <HomeTabs
            tabsContent={tabsToRender}
            variant={component.tabStyle ? component.tabStyle : "line-secondary"}
            tabType={component.tabType}
            className="deal_catalog"
            alignment={component?.heading_position}
            analytics={{link_name: `${analyticsData?.page_name}: deal: ${component.title}:`}}
          ></HomeTabs>
        )}
    </>
  );
};
DealCatalog.propTypes = {
  component: PropTypes.any,
  analyticsData: PropTypes.any,
};

DealCatalog.defaultProps = {
  component: {},
  analyticsData: {},
};
export default DealCatalog;
